export enum ShipmentStatusEnum {
  DRAFT = 'En Creación',
  ACTIVE = 'Activo',
  ANNULLED = 'Anulada',
  REPLACED = 'Sustituida',
  DELIVERED = 'Entregado',
  DEFAULT = 'Desconocida',
}

export enum SStatusEnum {
  ACTIVE = '1',
  INACTIVE = '2',
  DELETED = '3',
  PAID = '10',
  PARTIAL_PAID = '19',
  PENDING = '18',
  RECEIVED = '20',
  PROCESSED = '21',
  DELIVERED = '22',
}
